import { MoveEventsBerthCall } from './MoveEventsBerthCall';

export class MoveEventsPortCall {
    constructor(
        shipId: number,
        toVoyageNumber: string,
        fromPortCallId: number,
        toPortCallId: number,
        toPortId: number | null,
        moveEventsBerthCallList: MoveEventsBerthCall[]
    ) {
        this.shipId = shipId;
        this.toVoyageNumber = toVoyageNumber;
        this.fromPortCallId = fromPortCallId;
        this.toPortCallId = toPortCallId;
        this.toPortId = toPortId;
        this.moveEventsBerthCallList = moveEventsBerthCallList;
    }
    shipId: number;
    toVoyageNumber: string;
    fromPortCallId: number;
    toPortCallId: number;
    toPortId: number | null;
    moveEventsBerthCallList: MoveEventsBerthCall[];
}
